import React from "react";
import { Chip } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import useAuth from "../hooks/useAuth";

export default function ReadOnlyBadge() {
  const { isReadOnly } = useAuth();

  if (!isReadOnly) return null;

  return (
    <Chip
      icon={<LockIcon fontSize="small" />}
      label="View Only"
      color="warning"
      size="small"
      sx={{
        fontWeight: 600,
        height: "28px",
        "& .MuiChip-icon": {
          fontSize: "1rem",
        },
      }}
    />
  );
}

